<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="1100px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">选择评审组专家</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- 检索功能区 -->
      <v-form v-model="formValid" ref="formRef" lazy-validation>
      <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
        <v-layout row wrap>
          <v-flex d-flex xs10>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-text-field
                    label="姓名"
                    v-model="form.name"
                    :clearable="true"
                    hide-details
                />
              </v-flex>
            </v-layout>
          </v-flex>
              <v-flex d-flex xs2 text-xs-center>
                <div>
                  <v-btn color="primary" @click="onSearch">
                    <v-icon dark>search</v-icon>
                    检索
                  </v-btn>
                </div>
              </v-flex>
        </v-layout>
      </v-container>
      </v-form>

      <v-divider/>

      <v-data-table
          :headers="headers"
          :loading="loading"
          item-key="dbid"
          :pagination.sync="query"
          :items=this.expertItem
          :rows-per-page-items="[1,25,50]"
          v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
                v-model="props.selected"
                primary
                hide-details
                @change="onSelect(props.item)"
            ></v-checkbox>
            <!--检查框点击事件@change="onSelect"-->
          </td>
          <td>

            {{ props.index + 1}}
          </td>
          <td>{{ props.item.number }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.institution }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.education }}</td>
          <td>
            <span>{{ props.item.areaex? props.item.areaex.map(a => `${a.name}`).join(',') : ''}}</span>
          </td>
          <td>
            <span>{{ props.item.direction? props.item.direction.map(a => `${a.name}`).join(',') : ''}}</span>
          </td>
          <td>{{ props.item.phone }}</td>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer/>

        <v-flex xs2>
          <v-select
              label="排序"
              v-model="rank"
              :items="validRanks"
              :rules="rules.notEmplRequired"
          />
        </v-flex>

        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSaveExpert">保存</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
const baseURI = '/api/syst/expert';
const reviewExpertURI = '/api/proj/review-expert';
export default {
  mixins: [mixin.edit(baseURI)],
  props: ['reviewId','expert'],
  name: "Edit",
  data() {
    return {
      formValid: false,

      selected: [],

      expertItem: [],

      item : {},

      rank : '',

      rankItems: [
        1, 2, 3, 4, 5,
        6, 7, 8, 9, 10,
        11
      ],

      // 表头
      headers: [
        {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
        {text: '用户名', align: 'left', sortable: true, value: 'username'},
        {text: '姓名', align: 'left', sortable: true, value: 'name'},
        {text: '工作单位', align: 'left', sortable: true, value: 'institution'},
        {text: '职称', align: 'left', sortable: true, value: 'title'},
        {text: '学位', align: 'left', sortable: true, value: 'education'},
        {text: '研究领域', align: 'left', sortable: true, value: 'area'},
        {text: '研究方向', align: 'left', sortable: true, value: 'direction'},
        {text: '联系电话', align: 'left', sortable: true, value: 'phone'},
      ],

      // 检索、分页、排序条件条件
      query: {
        name: '',
        areaId: '',
        direcId: '',

        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        name: '',
        areaId: '',
        direcId: '',
      },

      freshItem: {
        name: '',
        areaId: '',
        direcId: '',
      },

      /**
       * 验证规则
       */
      rules: {
        emplRequired: [
          v => ((this.tab === 'tab-not-empl') || !!v) || '必填项。'
        ],
      }

    }
  },

  computed: {
    validRanks() {
      const vm = this
      if (vm.reviewId) {
        vm.axios.get(baseURI, {params: {limit: 65535, disabled: 'F'}}).then(
            rspExp => {
              vm.expertItem = rspExp.data.items;
              const rr = vm.expert.map(v => v.expertId)
              vm.expertItem = vm.expertItem.filter(v => !rr.includes(v.dbid))
            })
        const rr = vm.expert.map(v => v.rank);
        return vm.rankItems.filter(v => !rr.includes(v));
      }
      return vm.rankItems;
    },
  },

  methods : {

    onSelect(item) {
      // 确保只选中当前项
      this.selected = [item];
    },

    // 检索响应函数
    onSearch() {
      Object.assign(this.query, this.form);

      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.expertItem = rsp.data.items;
              }
          )
    },

    //保存专家
    onSaveExpert() {
      const vm = this

      if (vm.selected[0]) {
        if (vm.rank) {
          let selecedExpert =
              {
                "projReviewId": this.reviewId,
                "expertId": vm.selected[0].dbid,
                "name": vm.selected[0].name,
                "age": vm.selected[0].birthday ? (new Date(new Date() - new Date(vm.selected[0].birthday)).getFullYear() - 1970) : null,
                "sex": null,
                "titleId": vm.selected[0].titleId,
                "educId": vm.selected[0].acadDegreeId,
                "institution": vm.selected[0].institution,
                "rank": vm.rank,
              }

          vm.axios.post(reviewExpertURI, selecedExpert).then(rsp => {
            vm.visible = false;
            vm.rank = null
            vm.$emit('ok', rsp.data);
            vm.loading = false;
          })
              .finally(ex => {
                    vm.loading = false;
                    if (ex) window.console.error(ex);
                  }
              )
        }
        else
        {
          alert("请指定专家排序！")
        }
      }
      else
      {
        alert("请选定专家！")
      }

    },

  }
}
</script>

<style scoped>

</style>